// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"5279":"380348ba76f4a827efe5","7229":"22fa6de8d6270a385585"}[chunkId] + ".js";
};